import styles from "./DateBar.module.css";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

function DateBar() {
	const { i18n } = useTranslation();

	useEffect(() => {
		document.body.dir = i18n.dir();
	}, [i18n, i18n.language]);

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};

	return (
		<div className={styles.datebar}>
			<h1>{getCurrentDate()}</h1>

			<p onClick={() => changeLanguage("ar")}>العربية</p>
			<p onClick={() => changeLanguage("en")}>English</p>
		</div>
	);
}

function getCurrentDate() {
	const currentDate = new Date();
	const formattedDate = format(currentDate, "EEEE, MMMM dd, yyyy");
	return formattedDate;
}

export default DateBar;
